export default "__VITE_ASSET__4c67ed27__"